import pageStyle from "./index.module.less";
import LangSelect from "@/components/langSelect";
import TimePicker from "@/components/timePicker";
import ChannelSelect from "@/components/channelSelect/index";
import { getImList, getImLog } from "../service";
import { Simple as Agent } from "@/views/ticket/components/agent";
import Type from "@/views/ticket/components/type";
import SelectInput from "../components/select_input";
import SessionHistory from "@/components/im/sessionhistory";

export default {
    name: "DataImRecord",
    data() {
        return {
            activeName: "session",
            pageStyle,
            query: {
                time: [],
                language: "",
                channels: "",
                tag_id: "",
                agent_id: "",
                selectInput: {},
                satisfaction: "",
                unsatisfied_reason: "",
                page: 0,
                prepage: 30
            },
            sessionData: {
                tableData: [],
                count: 0,
                loading: false
            },
            queryLog: {
                language: "",
                tag_id: "",
                channels: "",
                time: [],
                is_send: "",
                session_id: "",
                agent_id: "",
                keyword: "",
                page: 0,
                prepage: 30,
                selectInput: {}
            },
            logData: {
                tableData: [],
                count: 0,
                loading: false
            }
        };
    },
    components: { LangSelect, TimePicker, ChannelSelect, Agent, Type, SelectInput, SessionHistory },

    watch: {
        "$i18n.locale"() {
            if (this.activeName == "log") {
                this.queryLogList();
            } else {
                this.queryList();
            }
        },
        query: {
            deep: true,
            handler() {
                this.queryList();
            }
        },
        queryLog: {
            deep: true,
            handler() {
                this.queryLogList();
            }
        }
    },

    methods: {
        async queryList() {
            let { selectInput, time, ...reset } = this.query;
            this.sessionData.loading = true;
            let { list, count } = await getImList({
                [selectInput.type]: selectInput.value,
                ...reset,
                end_time: Math.floor(time[1].getTime() / 1000),
                start_time: Math.floor(time[0].getTime() / 1000)
            });
            this.sessionData.loading = false;
            this.sessionData.tableData = list;
            this.sessionData.count = count;
        },
        channelSelect(data) {
            this.query.channels = data;
        },
        channelSelectLog(data) {
            this.queryLog.channels = data;
        },
        async queryLogList() {
            let { selectInput, time, ...reset } = this.queryLog;
            this.logData.loading = true;
            let { list, total } = await getImLog({
                [selectInput.type]: selectInput.value,
                ...reset,
                end_time: Math.floor(time[1].getTime() / 1000),
                begin_time: Math.floor(time[0].getTime() / 1000)
            });
            this.logData.loading = false;
            this.logData.tableData = list;
            this.logData.count = total;
        }
    }
};
